var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPass = function SvgPass(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 33,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.06 0A4.06 4.06 0 0 0 0 4.06v24.88A4.06 4.06 0 0 0 4.06 33h19.202a4.06 4.06 0 0 0 4.06-4.06V4.06A4.06 4.06 0 0 0 23.262 0H4.06Zm22.096 27.732a4.06 4.06 0 0 1-4.06 4.06H5.226a4.06 4.06 0 0 1-4.06-4.06V5.226a4.06 4.06 0 0 1 4.06-4.06h16.87a4.06 4.06 0 0 1 4.06 4.06v22.506ZM7.539 12.953c-.792-1.291-.958-2.416-.917-3.207.042-.833.375-1.624 1-2.166.583-.5 1.583-1 2.999-.708.877.192 5.204.198 6.08 0 1.416-.292 2.375.167 3 .708.624.542.999 1.333.999 2.166.041.791-.125 1.874-.916 3.207-.77 1.312-2.338 2.81-3.697 3.97a3.673 3.673 0 0 1-4.77 0c-1.393-1.185-3.022-2.717-3.778-3.97Z",
    fill: "currentcolor"
  })));
};
export default SvgPass;